export const options: ISelectOption<string[]>[] = [
    {
        label: 'Lag 0',
        value: ['0', '0'],
    },
    {
        label: 'Lag 1-5',
        value: ['1', '5'],
    },
    {
        label: 'Lag 6-10',
        value: ['6', '10'],
    },
    {
        label: 'Lag 11-15',
        value: ['11', '15'],
    },
    {
        label: 'Lag 16-22',
        value: ['16', '22'],
    },
    {
        label: 'Lag 23-43',
        value: ['23', '43'],
    },
    {
        label: 'Lag 44+',
        value: ['44', '99999'],
    },
    {
        label: 'Lead 1-5',
        value: ['-5', '-1'],
    },
    {
        label: 'Lead 6-10',
        value: ['-10', '-6'],
    },
    {
        label: 'Lead 11-15',
        value: ['-15', '-11'],
    },
    {
        label: 'Lead 16-22',
        value: ['-22', '-16'],
    },
    {
        label: 'Lead 23-43',
        value: ['-43', '-23'],
    },
    {
        label: 'Lead 44+',
        value: ['-99999', '-44'],
    },
];
